export { TITLE, LABEL, NAME_1, DESCRIPTION_1, BUTTON } from './constants'
export type { TTeachersProps } from './types'
export { getTeachersData } from './api'
export * as images from './images'
